import { Box, styled } from "@mui/material";

export const Container = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(1.5)};
`;

export const SectionGroup = styled(Box)`
  .section-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: ${({ theme }) => theme.palette.action.hover};
    border: 1px solid ${({ theme }) => theme.palette.biarri.primary.lightGrey};
    border-bottom: none;
    border-radius: ${({ theme }) => `${theme.custom.shape.borderRadius.large} ${theme.custom.shape.borderRadius.large} 0 0`};
    padding: ${({ theme }) => `${theme.spacing(0.75)} ${theme.spacing(1.5)}`};
  }

  .section-body {
    border: 1px solid ${({ theme }) => theme.palette.biarri.primary.lightGrey};
    border-radius: ${({ theme }) => `0 0 ${theme.custom.shape.borderRadius.large} ${theme.custom.shape.borderRadius.large}`};
    padding: ${({ theme }) => theme.spacing(1.5)};
  }
`;

export const Section = styled(Box)`
  border: 1px solid ${({ theme }) => theme.palette.biarri.primary.lightGrey};
  border-radius: ${({ theme }) => theme.custom.shape.borderRadius.large};
  padding: ${({ theme }) => theme.spacing(1.5)};
`;

export const CheckboxRow = styled(Box)`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};
`;

export const Footer = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;
